var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { css, html, LitElement } from "lit";
import { customElement, state } from "lit/decorators.js";
const customEl = "range-table";
let RangeTable = class RangeTable extends LitElement {
    constructor() {
        super(...arguments);
        this._handleValueChange = (event) => {
            const value = event.detail.value;
            this._filterColumns(value);
            this._scrollToActiveCard(value);
        };
        this._handleMouseEnter = (event) => {
            if (this._rangeInput) {
                this._rangeInput.changeValue(event.target.dataset.rangeTo);
            }
        };
    }
    render() {
        return html ``;
    }
    createRenderRoot() {
        return this;
    }
    _filterColumns(value) {
        value = (typeof value === "string") ? parseInt(value) : value;
        this._columns?.forEach((col) => delete col.dataset.active);
        this._columns?.map((col) => {
            (col.dataset.rangeFrom && col.dataset.rangeFrom === "0") &&
                (col.dataset.rangeFrom = "-1");
            return col;
        }).filter((col) => ((col.dataset.rangeFrom && parseInt(col.dataset.rangeFrom) < value) &&
            (col.dataset.rangeTo && value <= parseInt(col.dataset.rangeTo)))).forEach((col) => col.dataset.active = "");
    }
    _scrollToActiveCard(value) {
        if (!this._columns)
            return;
        const activeCard = this._columns.find((col) => {
            const from = parseInt(col.dataset.rangeFrom ?? "-1");
            const to = parseInt(col.dataset.rangeTo ?? "9999");
            return from < value && value <= to;
        });
        if (activeCard) {
            const container = this.querySelector(".scroll-cards");
            if (container) {
                const containerRect = container.getBoundingClientRect();
                const cardRect = activeCard.getBoundingClientRect();
                const scrollLeft = container.scrollLeft +
                    cardRect.left -
                    containerRect.left -
                    container.clientWidth / 2 +
                    cardRect.width / 2;
                container.scrollTo({
                    left: scrollLeft,
                    behavior: "smooth",
                });
            }
        }
    }
    connectedCallback() {
        super.connectedCallback();
        this._rangeInput = this.querySelector("range-input") ?? undefined;
        this._columns = [
            ...this.querySelectorAll("[data-range-col]") ??
                undefined,
        ];
        this._filterColumns(this._rangeInput?.value ?? 10);
        this._columns?.forEach((col) => col.addEventListener("mouseenter", this._handleMouseEnter));
        this._rangeInput?.addEventListener("valueChanged", this._handleValueChange);
    }
    disconnectedCallback() {
        this._rangeInput?.removeEventListener("valueChanged", this._handleValueChange);
        this._columns?.forEach((col) => col.removeEventListener("mouseenter", this._handleMouseEnter));
        super.disconnectedCallback();
    }
};
RangeTable.styles = css ``;
__decorate([
    state(),
    __metadata("design:type", Function)
], RangeTable.prototype, "_rangeInput", void 0);
__decorate([
    state(),
    __metadata("design:type", Array)
], RangeTable.prototype, "_columns", void 0);
__decorate([
    state(),
    __metadata("design:type", Element)
], RangeTable.prototype, "_active", void 0);
RangeTable = __decorate([
    customElement(customEl)
], RangeTable);
export { RangeTable };
